/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
} from '@material-ui/core';
import {
    MoreVert as MoreVertIcon,
    Check as CheckIcon,
    Close as CloseIcon,
} from '@material-ui/icons';
import { useUpdate, useNotify, useRefresh } from 'react-admin';
import { useDataProvider } from 'react-admin';

const useStyles = makeStyles(theme => ({
    acceptIcon: {
        color: theme.palette.success?.main || '#4caf50',
    },
    rejectIcon: {
        color: theme.palette.error?.main || '#f44336',
    },
}));

interface ActionFieldProps {
    record?: any;
    source?: string;
    label?: string;
}

const ActionField: React.FC<ActionFieldProps> = ({ record }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [isLoading, setIsLoading] = useState(false);

    // Don't show the action menu if status is not pending
    if (!record || record.status !== 'pending') {
        return null;
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation(); // Prevent row click when clicking the action button
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = async (newStatus: 'accepted' | 'rejected') => {
        try {
            setIsLoading(true);
            if (newStatus === 'accepted') {
                await dataProvider.update('reviews', {
                    id: `${record.id}/accept`,
                    data: {},
                });

                notify(
                    `Review ${
                        newStatus === 'accepted' ? 'accepted' : 'rejected'
                    } successfully`,
                    { type: 'success' }
                );
            } else {
                await dataProvider.update('reviews', {
                    id: `${record.id}/reject`,
                    data: {},
                });
                notify(`Review rejected successfully`, { type: 'success' });
            }
            refresh();
        } catch (error) {
            notify('Error updating course status', { type: 'error' });
        }
        setIsLoading(false);
        handleClose();
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                aria-label="more"
                id="course-action-button"
                aria-controls={open ? 'course-action-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                disabled={isLoading}
                size="small"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="course-action-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem
                    onClick={e => {
                        e.stopPropagation();
                        handleAction('accepted');
                    }}
                >
                    <ListItemIcon>
                        <CheckIcon
                            fontSize="small"
                            className={classes.acceptIcon}
                        />
                    </ListItemIcon>
                    <ListItemText>Accept</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={e => {
                        e.stopPropagation();
                        handleAction('rejected');
                    }}
                >
                    <ListItemIcon>
                        <CloseIcon
                            fontSize="small"
                            className={classes.rejectIcon}
                        />
                    </ListItemIcon>
                    <ListItemText>Reject</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
};

export default ActionField;
